// src/pages/Dashboard/StatsTable.js
import React from "react";
import useChatbotStats from "./useChatbotStats";
import { Box, CircularProgress, Typography, Paper, Table, TableHead, TableRow, TableCell, TableBody, Divider, useTheme } from "@mui/material";

export default function ChatbotStatsTable() {
    const { stats, error, loading } = useChatbotStats();
    const theme = useTheme();

    if (loading)
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 3 }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }} color="text.primary">
                    Loading stats table...
                </Typography>
            </Box>
        );

    if (error) return <Typography color="error">{error}</Typography>;
    if (!stats) return <Typography color="text.primary">No stats available for this chatbot.</Typography>;

    return (
        <Paper sx={{ p: 3, bgcolor: "background.paper" }}>
            <Typography variant="h5" color="text.primary" gutterBottom>
                Knowledge Base Statistics
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Category</TableCell>
                        <TableCell align="right">Total Characters</TableCell>
                        <TableCell align="right">Total Words</TableCell>
                        <TableCell align="right">Total Source Tokens</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Private Documents</TableCell>
                        <TableCell align="right">{stats.privateDocs.total_page_characters}</TableCell>
                        <TableCell align="right">{stats.privateDocs.total_page_words}</TableCell>
                        <TableCell align="right">{stats.privateDocs.total_tokens}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Website Links</TableCell>
                        <TableCell align="right">{stats.websiteLinks.total_page_characters}</TableCell>
                        <TableCell align="right">{stats.websiteLinks.total_page_words}</TableCell>
                        <TableCell align="right">{stats.websiteLinks.total_tokens}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}>Total (Knowledge Base)</TableCell>
                        <TableCell align="right">{stats.totalCharacters}</TableCell>
                        <TableCell align="right">{stats.totalWords}</TableCell>
                        <TableCell align="right">{stats.totalTokens}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Chatbot Usage (Input + Output)</TableCell>
                        <TableCell colSpan={2}></TableCell>
                        <TableCell align="right">{stats.tokens.total_total_token}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    );
}